var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.status == -1
        ? _c(
            "v-chip",
            {
              attrs: {
                label: "",
                color: "red darken-4",
                "text-color": "#FFFFFF"
              }
            },
            [_vm._v("\n        Taken off and Canceled\n        ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.status == 0
        ? _c(
            "v-chip",
            {
              attrs: {
                label: "",
                color: "red darken-3",
                "text-color": "#FFFFFF"
              }
            },
            [_vm._v("\n\t    Cancelled\n\t    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.status == 3
        ? _c(
            "v-chip",
            { attrs: { label: "", color: "green", "text-color": "#FFFFFF" } },
            [_vm._v("\n\t    In Progress\n\t    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.status == 4
        ? _c(
            "v-chip",
            {
              attrs: {
                label: "",
                color: "blue lighten-1",
                "text-color": "#FFFFFF"
              }
            },
            [_vm._v("\n\t    Landed\n\t    ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }